import { render, staticRenderFns } from "./my-coupon-tab.vue?vue&type=template&id=5ac6bc00&scoped=true&"
import script from "./my-coupon-tab.vue?vue&type=script&lang=ts&"
export * from "./my-coupon-tab.vue?vue&type=script&lang=ts&"
import style0 from "./my-coupon-tab.vue?vue&type=style&index=0&id=5ac6bc00&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac6bc00",
  null
  
)

export default component.exports